import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=4524b73b"
import script from "./SurveyCard.vue?vue&type=script&lang=js"
export * from "./SurveyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports